const PICKER_QUERY = "picker";
export const PICKER_MODE_SESSION_KEY = "gvt-sidebar-picker";

/**
 * Alternative Ask ↔ Studio switchers, chosen with `?picker=` so the designs can be compared side by side.
 * `button` is the default sidebar; it can be named so it replaces a choice saved earlier in the session.
 */
export type PickerMode = "button" | "slack" | "switch" | "tabs";

const PICKER_MODES: readonly PickerMode[] = [
	"button",
	"slack",
	"switch",
	"tabs",
];

const parsePickerMode = (value: string | null): PickerMode | undefined =>
	PICKER_MODES.find((mode) => mode === value);

export const pickerMode = (): PickerMode => {
	const fromQuery = parsePickerMode(
		new URLSearchParams(window.location.search).get(PICKER_QUERY),
	);
	if (fromQuery) {
		sessionStorage.setItem(PICKER_MODE_SESSION_KEY, fromQuery);
		return fromQuery;
	}

	return (
		parsePickerMode(sessionStorage.getItem(PICKER_MODE_SESSION_KEY)) ?? "button"
	);
};

/** Keep the picker on Ask ↔ Studio hops so the chrome stays in this mode. */
export const pickerHref = (path: string, mode: PickerMode): string => {
	const url = new URL(path, window.location.origin);
	url.searchParams.set(PICKER_QUERY, mode);
	return `${url.pathname}${url.search}`;
};
